import React, { useEffect, useState } from "react";
import { PRIMARY_COLOR } from "../../../helpers/Constants";
import useTranslation from "../../../hooks/useTranslation";
import { isMobile, isTablet } from "react-device-detect";

const Toogle = ({ titles: titlesProps, initialState, isActive, onClick }) => {
  const T = useTranslation();
  const [titles, setTitles] = useState(titlesProps || []);
  const [current, setCurrent] = useState(initialState);
  const [active, setActive] = useState(isActive || true);

  const handlerToogle = (item) => {
    if (!active) return;
    setCurrent(item);
    if (onClick) {
      onClick({
        active: item,
        title: titles[item],
      });
    }
  };

  useEffect(() => {}, [current]);

  return (
    <>
      <div
        style={{ opacity: active ? "100%" : "50%" }}
        className="flex  items-center h-[40px] cursor-pointer  "
      >
        <div className="flex p-[8px] items-center gap-0 bg-white rounded rounded-[8px] border border-[2px] border-[#BBDFDB]">
          {titles.map((item, index) => {
            return (
              <div
                key={index}
                onClick={() => handlerToogle(index)}
                style={{
                  backgroundColor: current === index ? PRIMARY_COLOR : "white",
                  transition: "ease-in",
                  color: current === index ? "white" : "black",
                }}
                className={`flex justify-center rounded-[6px] bg-[#fff] h-[32px] px-2 w-auto font-[600] items-center 
        ${isMobile && !isTablet ? "text-xs" : "text-sm"}`}
              >
                {T(item)}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Toogle;
